// ==========================================================
// Shop & VIP Pass Modal Controller (Monetization UI)
// ==========================================================

import { EconomyManager } from '../engine/EconomyManager';
import { AdManager } from '../engine/AdManager';
import { sounds } from '../audio/SoundEffects';
import { i18n } from '../i18n/I18nService';

export class ShopModalController {
  private modalEl: HTMLElement;
  private coinDisplayEl: HTMLElement;
  private vipBadgeEl: HTMLElement;
  private btnWatchAd: HTMLButtonElement;
  private btnBuyVIP: HTMLButtonElement;
  private btnClose: HTMLButtonElement;
  private onBalanceUpdateCallback?: () => void;

  constructor() {
    this.modalEl = document.getElementById('modal-shop')!;
    this.coinDisplayEl = document.getElementById('shop-coin-balance')!;
    this.vipBadgeEl = document.getElementById('shop-vip-status')!;
    this.btnWatchAd = document.getElementById('btn-shop-watch-ad') as HTMLButtonElement;
    this.btnBuyVIP = document.getElementById('btn-shop-buy-vip') as HTMLButtonElement;
    this.btnClose = document.getElementById('btn-close-shop') as HTMLButtonElement;

    this.initEvents();
  }

  private initEvents() {
    this.btnClose?.addEventListener('click', () => {
      sounds.playClick();
      this.close();
    });

    // 1. Rewarded Ad Simulation
    this.btnWatchAd?.addEventListener('click', () => {
      sounds.playClick();
      this.simulateRewardedAd();
    });

    // 2. VIP Pass Toggle / Purchase
    this.btnBuyVIP?.addEventListener('click', () => {
      sounds.playClick();
      const isCurrentlyVIP = EconomyManager.isVIP();
      EconomyManager.setVIP(!isCurrentlyVIP);
      sounds.playFanfare(3);
      this.updateUI();
      if (this.onBalanceUpdateCallback) this.onBalanceUpdateCallback();
    });

    // 3. Coin Pack Purchases
    document.querySelectorAll('.btn-buy-coin-pack').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const target = e.currentTarget as HTMLElement;
        const amount = parseInt(target.getAttribute('data-coins') || '1000', 10);
        sounds.playClick();
        EconomyManager.addCoins(amount);
        sounds.playFanfare(2);
        this.updateUI();
        if (this.onBalanceUpdateCallback) this.onBalanceUpdateCallback();
      });
    });
  }

  public setOnBalanceUpdate(cb: () => void) {
    this.onBalanceUpdateCallback = cb;
  }

  public open() {
    this.updateUI();
    this.modalEl.classList.remove('hidden');
  }

  public close() {
    this.modalEl.classList.add('hidden');
  }

  private async simulateRewardedAd() {
    this.btnWatchAd.disabled = true;
    const origText = this.btnWatchAd.textContent;
    this.btnWatchAd.textContent = i18n.getLanguage() === 'ja' ? '広告を再生中...' : 'Playing Sponsor Ad...';

    await AdManager.showRewardedAd(() => {
      this.updateUI();
      if (this.onBalanceUpdateCallback) this.onBalanceUpdateCallback();
    });

    this.btnWatchAd.disabled = false;
    this.btnWatchAd.textContent = origText;
    this.updateUI();
  }

  public updateUI() {
    const coins = EconomyManager.getCoins();
    const isVIP = EconomyManager.isVIP();
    const lang = i18n.getLanguage();

    if (this.coinDisplayEl) {
      this.coinDisplayEl.textContent = `🪙 ${coins.toLocaleString()}`;
    }

    if (this.vipBadgeEl) {
      if (isVIP) {
        this.vipBadgeEl.textContent = '👑 VIP ACTIVE (ALL 112 STAGES UNLOCKED)';
        this.vipBadgeEl.className = 'vip-status-tag active';
      } else {
        this.vipBadgeEl.textContent = lang === 'ja' ? '通常職人 (Standard)' : 'Standard Artisan';
        this.vipBadgeEl.className = 'vip-status-tag';
      }
    }

    if (this.btnBuyVIP) {
      if (isVIP) {
        this.btnBuyVIP.textContent = lang === 'ja' ? '👑 VIP 有効化済み (タップで解除)' : '👑 VIP ACTIVE (Tap to Toggle)';
        this.btnBuyVIP.classList.add('active');
      } else {
        this.btnBuyVIP.textContent = lang === 'ja' ? '👑 VIP職人パスを有効化 (無料・全112ステージ解放)' : '👑 Activate VIP Pass (Free — unlocks all 112 stages)';
        this.btnBuyVIP.classList.remove('active');
      }
    }
  }
}
